import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getWishList } from "../../redux/features/product/productSlice";
import ProductCard from "../Products/ProductCard";
import Spinner from "../Spinner";

const Liked = () => {
  const dispatch = useDispatch();

  const { wishList, isLoading } = useSelector((state) => state.products);

  useEffect(() => {
    dispatch(getWishList());
  }, [dispatch]);

  return (
    <div className=" min-h-screen px-[10px] md:px-[20px] lg:px-[3%]">
      {/* <Link to="/">
        <img className=" h-16" src="/utils/back.png" alt="" />
      </Link> */}
      {isLoading ? (
        <div>
          <Spinner />
        </div>
      ) : (
        <>
          {wishList?.length === 0 ? (
            <div className="text-center">Not found!</div>
          ) : (
            <div className=" min-h-[30vh] lg:w-[75vw] pb-16 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 justify-center ">
              {wishList.map((p) => (
                <ProductCard
                  key={p._id}
                  name={p.name}
                  image={p.images[0]?.url}
                  price={p.price}
                  id={p._id}
                  description={p.description}
                  ratings={p.ratings}
                  numOfReviews={p.numOfReviews}
                />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Liked;
